import { queryOptions } from '@tanstack/react-query';

import { type UnsurveyedQueryParams, unsurveyedService } from '~api/services';

/**
 * Generate query options for fetching unsurveyed sites based on blast name and mine code
 * @param params - Query parameters including blast name and mine code
 * @returns Query options for fetching unsurveyed sites data
 */
function unsurveyedQueryOptions(params: UnsurveyedQueryParams) {
  return queryOptions({
    queryKey: ['unsurveyed-sites', params],
    queryFn: () => unsurveyedService.getUnsurveyedSites(params),
  });
}

export { unsurveyedQueryOptions };
